import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import MoreButtonSkeleton from './MoreButtonSkeleton';
import { useCachedFetch } from './../../hooks/useCachedFetch';
import './MoreButton.scss';

const MoreButton = () => {
    const { i18n } = useTranslation();
    const currentLang = i18n.language;

    const { data: mainData, loading: dataLoading, error: dataError } = useCachedFetch('/data/locales/mainData.json');

    const [isLoading, setIsLoading] = useState(true);
    const [hasData, setHasData] = useState(false);

    useEffect(() => {
        if (dataLoading) return;

        if (dataError || !mainData?.TopMainData?.MoreButton?.contentAccent) {
            setHasData(false);
        } else {
            setHasData(true);
        }

        setIsLoading(false);
    }, [dataLoading, dataError, mainData]);

    const mainContent = useMemo(() => 
        mainData?.TopMainData?.MoreButton || null,
        [mainData]
    );

    const buttonText = useMemo(() => 
        mainContent?.contentAccent?.[currentLang] || mainContent?.contentAccent?.en || '',
        [mainContent, currentLang]
    );

    const scrollToSection = useCallback(() => {
        const section = document.getElementById("need__section");
        if (section) {
            section.scrollIntoView({ behavior: "smooth" });
        }
    }, []);

    const swipeLineSvg = useMemo(() => (
        <svg
            className="swipe-line"
            width="2"
            height="100"
            viewBox="0 0 3 87"
            fill="none"
            stroke="#fff"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M0.749996 0L0.749996 87"
                stroke="white"
                strokeWidth="2"
            />
        </svg>
    ), []);

    if (isLoading) {
        return <MoreButtonSkeleton />;
    }

    if (!hasData || !mainContent || !buttonText) {
        return null;
    }

    return (
        <button className="more__button" onClick={scrollToSection}>
            <span>{buttonText}</span>
            {swipeLineSvg}
        </button>
    );
};

export default React.memo(MoreButton);